<template lang="pug" src="./custom-menu-customization.pug"></template>

<script>
import { trigger } from '@/shared/functionality/mixins'

export default {
  props: ['props'],
  mixins: [trigger],
  data () {
    return {
      bg: false,
      bottom: false,
      scrolling: 0,
      current: ''
    }
  },
  methods: {
    scroller ({going, direction}) {
      if (going === 'out' && direction === 'top') {
        this.bg === true ? this.bg = false : this.bg = true
      }
      if (going === 'in' && direction === 'bottom') {
        this.bg = false
        this.current = 0
      }
    },
    stop ({going, direction}) {
      if (going === 'in' && direction === 'top') {
        this.bottom = true
      }
      if (going === 'out' && direction === 'bottom') {
        this.bottom = false
      }
    },
    animate ({going, direction}) {
      if (going === 'in' && direction === 'top') {
        this.current++
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-menu-customization/custom-menu-customization.vue